import { Pipe, PipeTransform } from '@angular/core';
import { ConferenceRegistrationStepName, RegistrantKeys } from 'ag-common-lib/public-api';
import { map, Observable } from 'rxjs';
import { AttendeeDetailsModalService } from '../attendee-details-modal.service';

@Pipe({ name: 'conferenceGeneralInfoFieldVisible' })
export class GeneralInfoFieldVisiblePipe implements PipeTransform {
  constructor(private attendeeDetailsModalService: AttendeeDetailsModalService) {}

  transform(fieldName: string): Observable<boolean> {
    if (!fieldName) {
      return null;
    }
    return this.attendeeDetailsModalService.conferencePersonalInfoExcludedFields$.pipe(
      map(excludedFields => {
        return !excludedFields?.some(field => field === fieldName)
      }),
    );
  }
}
